module.exports = __webpack_public_path__ + "static/media/Double Mat.5f300c59.png";